import axios from 'axios';

const getApiBaseUrl = () => {
  const configuredUrl = process.env.REACT_APP_API_URL;

  if (process.env.NODE_ENV === 'production') {
    if (!configuredUrl || configuredUrl.includes('localhost')) {
      return '/api/v1';
    }
  }

  return configuredUrl || 'http://localhost:3001/api/v1';
};

export const API_BASE_URL = getApiBaseUrl();

// Create an axios instance with the base URL from environment variables
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors (token expired)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      // Optionally redirect to login page
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
